import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function MedicationsIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.04303 1.33398H9.9518C10.566 1.33398 10.8731 1.33398 11.0639 1.52924C11.4197 1.89336 11.4197 3.44127 11.0639 3.80539C10.8731 4.00065 10.566 4.00065 9.9518 4.00065H6.04303C5.42883 4.00065 5.12173 4.00065 4.93092 3.80539C4.57511 3.44127 4.57511 1.89336 4.93092 1.52924C5.12173 1.33398 5.42883 1.33398 6.04303 1.33398Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M5.3304 4C5.44036 4.21991 5.49534 4.32987 5.53444 4.43713C5.73848 4.99677 5.68244 5.61821 5.38159 6.13232C5.32393 6.23085 5.25017 6.32921 5.10264 6.5259L4.83369 6.88453C4.53364 7.2846 4.38362 7.4846 4.2749 7.70373C4.16507 7.92513 4.08654 8.16067 4.04158 8.40367C3.99707 8.64427 3.99707 8.89427 3.99707 9.39433V10.6667C3.99707 12.5523 3.99707 13.4951 4.58286 14.0809C5.16864 14.6667 6.11145 14.6667 7.99707 14.6667C9.88267 14.6667 10.8255 14.6667 11.4113 14.0809C11.9971 13.4951 11.9971 12.5523 11.9971 10.6667V9.39433C11.9971 8.89427 11.9971 8.64427 11.9525 8.40367C11.9076 8.16067 11.8291 7.92513 11.7193 7.70373C11.6105 7.4846 11.4605 7.2846 11.1605 6.88453L10.8915 6.5259C10.744 6.32921 10.6702 6.23085 10.6125 6.13232C10.3117 5.61821 10.2557 4.99677 10.4597 4.43713C10.4988 4.32987 10.5538 4.21991 10.6637 4"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M7.99674 8.66602V11.9993M6.33008 10.3327H9.66341"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
